export default "__VITE_ASSET__fd00b16a__"